<style lang="scss" scoped>
.search-bar {
    display: flex;
    align-items: center;
    transition: all 0.2s;
    border-radius: 4px;
    box-shadow: none;
    height: 36px;

    input {
        width: 0;
        opacity: 0;
        transition: all 0.2s;
        background-color: transparent;
        border: 0;
        padding: 8px 0;
        font-size: 0.875rem;
        line-height: 1.125rem;
        box-shadow: none;
        outline: none;

        &:focus {
            box-shadow: none;
            outline: none;
        }

        &::placeholder {
            color: #afafaf;
        }
    }

    &.visible {
        background-color: #f6f6f8;

        input {
            opacity: 1;
            width: 214px;
            padding: 8px 16px;
        }
    }

    .search-toggle {
        cursor: pointer;
        display: flex;
        align-items: center;
    }
}
</style>

<template>
    <div class="search-bar" :class="{visible: visible}">
        <input type="text" v-on:keyup.enter="buttonClick" v-model="searchTerm" :placeholder="placeholder">
        <div class="search-toggle" @click.prevent="buttonClick">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Ui.SearchBar",

    data() {
        return {
            visible: false,
            searchTerm: '',
        }
    },

    props: {
        open: {
            type: Boolean,
            required: false
        },

        placeholder: {
            type: String,
            required: false
        },
    },

    mounted() {
        if (this.open) this.visible = true;
    },

    methods: {
        buttonClick() {
            if (!this.visible) {
                this.visible = true;
            } else if (this.searchTerm != null && this.searchTerm != '') {
                const searchPath = `${this.$root.searchUrl}?s=${this.searchTerm}`;
                window.location.href = searchPath;
            }
        }
    }
}
</script>